import axios from '../axios';

/**
 * 分页获取托管专利
 * 
 * @url /patent_trusteeship/index
 * 
 */

export function ObtainEscrowPatents(params) {
    return axios.post('/patent_trusteeship/index', params)
}
/**
 * 专利托管详情
 * 
 * @url /patent_trusteeship/detail
 * 
 */

export function Escrowdetails(params) {
    return axios.post('/patent_trusteeship/detail', params)
}
/**
 * 新增托管
 * 
 * @url /patent_trusteeship/save
 * 
 */

export function addEscrow(params) {
    return axios.post('/patent_trusteeship/save', params)
}
/**
 * 取消专利托管
 * 
 * @url /patent_trusteeship/remove
 * 
 */

export function UnmanageRemove(params) {
    return axios.post('/patent_trusteeship/remove', params)
}

/**
 * 专利同步
 * 
 * @url /patent_trusteeship/sync_patent
 * 
 */

export function patenttrusteeshipsyncpatent(params) {
    return axios.post('/patent_trusteeship/sync_patent', params)
}

/**
 * 专利托管更新
 * 
 * @url /patent_trusteeship/update
 * 
 */

export function patenttrusteeshipupdate(params) {
    return axios.post('/patent_trusteeship/update', params)
}
/**
 * 专利托管匹配度
 * 
 * @url /patent_trusteeship/match
 * 
 */

export function patenttrusteeshipmatch(params) {
    return axios.post('/patent_trusteeship/match', params)
}

/**
 * 分页获取商标
 * 
 * @url /trademark_trusteeship/index
 * 
 */

export function Obtaintrademark(params) {
    return axios.post('/trademark_trusteeship/index', params)
}
/**
 * 商标详情
 * 
 * @url /trademark_trusteeship/detail
 * 
 */

export function Trademarkdetails(params) {
    return axios.post('/trademark_trusteeship/detail', params)
}
/**
 * 检索商标详情
 * 
 * @url /trademark/detail
 */

export function trademarkdetail(params) {
    return axios.post('/trademark/detail', params)
}
/**
 * 新增商标托管
 * 
 * @url /trademark_trusteeship/save
 * 
 */

export function AddTrademark(params) {
    return axios.post('/trademark_trusteeship/save', params)
}
/**
 * 取消商标托管
 * 
 * @url /trademark_trusteeship/remove
 * 
 */

export function trademarktrusteeshipremove(params) {
    return axios.post('/trademark_trusteeship/remove', params)
}
/**
 * 商标同步
 * 
 * @url /trademark_trusteeship/sync_trademark
 * 
 */

export function trademarktrusteeshipsynctrademark(params) {
    return axios.post('/trademark_trusteeship/sync_trademark', params)
}
/**
 * 保存商标托管修改
 * 
 * @url /trademark_trusteeship/update
 * 
 */

export function trademarktrusteeshipupdate(params) {
    return axios.post('/trademark_trusteeship/update', params)
}
// /**
//  * 商标检索
//  * 
//  * @url /trademark/query
//  * 
//  */

// export function trademarkquery(params) {
//     return axios.post('/trademark/query', params)
// }
// /**
//  * 商标检索ES
//  * 
//  * @url /trademark/query_key_es
//  * 
//  */

// export function trademarkquerykeyes(params) {
//     return axios.post('/trademark/query_key_es', params)
// }
/**
 * 商标检索2.0
 * 
 * @url /trademark/query_key_es
 * 
 */

export function trademarkquerykeyes(params) {
    return axios.post('/trademark/search', params)
}
/**
 * 将商标设置为主品牌
 * 
 * @url /trademark_trusteeship/default
 * 
 */

export function trademarktrusteeshipdefault(params) {
    return axios.post('/trademark_trusteeship/default', params)
}
/**
 * 获取主品牌
 * 
 * @url /trademark_trusteeship/my
 * 
 */

export function trademarktrusteeshipmy(params) {
    return axios.post('/trademark_trusteeship/my', params)
}
/**
 * 专利检索
 * 
 * @url /patent/query
 * 
 */

export function patentquery(params) {
    return axios.post('/patent/query', params)
}
// /**
//  * 根据技术关键词专利检索
//  * 
//  * @url /patent/query_key
//  * 
//  */

// export function patentquerykey(params) {
//     return axios.post('/patent/query_key', params)
// }
/**
 * 根据技术关键词专利检索
 * 
 * @url /patent/query_key
 * 
 */

export function patentquerykey(params) {
    return axios.post('/patent/search', params)
}
/**
 * 分页获取竞争对手
 * 
 * @url /ent_monitor/index
 * 
 */

export function opponentList(params) {
    return axios.post('/ent_monitor/index', params)
}
/**
 * 移除竞争对手
 * 
 * @url /ent_monitor/remove
 * 
 */

export function entmonitorremove(params) {
    return axios.post('/ent_monitor/remove', params)
}

/**
 * 获取竞争对手详情
 * 
 * @url /ent_monitor/detail
 * 
 */

export function monitordetail(params) {
    return axios.post('/ent_monitor/detail', params)
}
/**
 * 添加竞争对手
 * 
 * @url /ent_monitor/detail
 * 
 */

export function ADDmonitordetail(params) {
    return axios.post('/ent_monitor/save', params)
}
/**
 * 删除竞争对手
 * 
 * @url /ent_tech_monitor/delete
 * 
 */

export function removeMonitordetail(params) {
    return axios.post('/ent_monitor/delete', params)
}
/**
 * 企业检索
 * 
 * @url /ent/search
 * 
 */

export function entsearch(params) {
    return axios.post('/ent/search', params)
}
/**
 * 企业详情
 * 
 * @url /ent/detail
 * 
 */

export function entdetail(params) {
    return axios.post('/ent/detail', params)
}
/**
 * 商标监控
 * 
 * @url /trademark/append
 * 
 */

export function trademarkappend(params) {
    return axios.post('/trademark/append', params)
}

// 专利管理--------------------------------------
/**
 * 分页获取企业专利
 * 
 * @url /patent_trusteeship/ent_patent
 * 
 */

export function patenttrusteeshipentpatent(params) {
    return axios.post('/patent_trusteeship/ent_patent', params)
}
/**
 * 分页获取个人专利
 * 
 * @url /patent_trusteeship/my
 * 
 */

export function patenttrusteeshipmy(params) {
    return axios.post('/patent_trusteeship/my', params)
}
/**
 * 删除专利
 * 
 * @url /patent_trusteeship/remove
 * 
 */

export function patenttrusteeshipremove(params) {
    return axios.post('/patent_trusteeship/remove', params)
}
/**
 * 专利详情
 * 
 * @url /patent_trusteeship/detail
 * 
 */

export function patenttrusteeshipdetail(params) {
    return axios.post('/patent_trusteeship/detail', params)
}
/**
 * 新增专利
 * 
 * @url /patent_trusteeship/save
 * 
 */

export function patenttrusteeshipsave(params) {
    return axios.post('/patent_trusteeship/save', params)
}

/**
 * 个人关注的专利
 * 
 * @url /follow_patent/my_follow
 * 
 */

export function followpatentmyfollow(params) {
    return axios.post('/follow_patent/my_follow', params)
}


// 商标管理--------------------------------------
/**
 * 分页获取企业商标
 * 
 * @url /trademark_trusteeship/index
 * 
 */

export function trademarktrusteeshipindex(params) {
    return axios.post('/trademark_trusteeship/index', params)
}
/**
 * 分页获取个人商标
 * 
 * @url /trademark_trusteeship/person
 * 
 */

export function trademarktrusteeshipperson(params) {
    return axios.post('/trademark_trusteeship/person', params)
}
// /**
//  * 删除商标
//  * 
//  * @url /trademark_trusteeship/remove
//  * 
//  */

//  export function trademarktrusteeshipremove(params) {
//     return axios.post('/trademark_trusteeship/remove', params)
// }
/**
 * 商标详情
 * 
 * @url /trademark_trusteeship/detail
 * 
 */

export function trademarktrusteeshipdetail(params) {
    return axios.post('/trademark_trusteeship/detail', params)
}
/**
 * 新增商标
 * 
 * @url /trademark_trusteeship/save
 * 
 */

export function trademarktrusteeshipsave(params) {
    return axios.post('/trademark_trusteeship/save', params)
}
// /**
//  * 将商标设为主品牌
//  * 
//  * @url /trademark_trusteeship/default
//  * 
//  */

//  export function trademarktrusteeshipdefault(params) {
//     return axios.post('/trademark_trusteeship/default', params)
// }
/**
//  * 商标修改
//  * 
//  * @url /trademark_trusteeship/update
//  * 
//  */

//  export function trademarktrusteeshipupdate(params) {
//     return axios.post('/trademark_trusteeship/update', params)
// }

/**
 * 分页获取企业版权
 * 
 * @url /copyright_trusteeship/ent_copyright
 * 
 */

export function copyrighttrusteeshipentcopyright(params) {
    return axios.post('/copyright_trusteeship/ent_copyright', params)
}
/**
 * 企业版权增值服务
 * 
 * @url /copyright_trusteeship/update
 * 
 */

export function copyrighttrusteeshipupdate(params) {
    return axios.post('/copyright_trusteeship/update', params)
}
/**
 * 企业版权删除
 * 
 * @url /copyright_trusteeship/remove
 * 
 */

export function copyrighttrusteeshipremove(params) {
    return axios.post('/copyright_trusteeship/remove', params)
}
/**
 * 企业版权新增
 * 
 * @url /copyright_trusteeship/save
 * 
 */

export function copyrighttrusteeshipsave(params) {
    return axios.post('/copyright_trusteeship/save', params)
}
/**
 * 分页获取企业专利瞭望台
 * 
 * @url /follow_patent/ent_follow
 * 
 */

export function followpatententfollow(params) {
    return axios.post('/follow_patent/ent_follow', params)
}
/**
 * 企业专利瞭望台取消关注
 * 
 * @url /follow_patent/remove
 * 
 */

export function followpatentremove(params) {
    return axios.post('/follow_patent/remove', params)
}
/**
 * 专利详情
 * 
 * @url /patent/detail
 * 
 */

export function patentdetail(params) {
    return axios.post('/patent/detail', params)
}
/**
 * 企业商标瞭望台取消关注
 * 
 * @url /follow_trademark/remove
 * 
 */

export function followtrademarkremove(params) {
    return axios.post('/follow_trademark/remove', params)
}
/**
 * 企业商标瞭望台
 * 
 * @url /follow_trademark/ent_follow
 * 
 */

export function followtrademarkentfollow(params) {
    return axios.post('/follow_trademark/ent_follow', params)
}

// 个人关注商标
/**
 * 
 * @url /follow_trademark/my_follow
 * 
 */

export function followtrademarkmyfollow(params) {
    return axios.post('/follow_trademark/my_follow', params)
}
/**
 * 获取商标国际分类
 * 
 * @url /trademark_tools/class
 * 
 */

export function trademarktoolsclass(params) {
    return axios.post('/trademark_tools/class', params)
}

// /**
//  * 取消关注
//  * 
//  * @url /follow_trademark/remove
//  * 
//  */

//  export function followtrademarkremove(params) {
//     return axios.post('/follow_trademark/remove', params)
// }
/**
 * 推送到企业的商标
 * 
 * @url /follow_trademark/my_share
 * 
 */

export function followtrademarkmyshare(params) {
    return axios.post('/follow_trademark/my_share', params)
}
/**
 * 取消推送到企业
 * 
 * @url /follow_trademark/close
 * 
 */

export function followtrademarkclose(params) {
    return axios.post('/follow_trademark/close', params)
}
/**
 * 推送到企业商标瞭望台
 * 
 * @url /follow_trademark/push
 * 
 */

export function followtrademarkpush(params) {
    return axios.post('/follow_trademark/push', params)
}

/**
 * 分页获取个人监控企业
 * 
 * @url /ent_monitor/my_monitor
 * 
 */

export function entmonitormymonitor(params) {
    return axios.post('/ent_monitor/my_monitor', params)
}
/**
 * 我关注的企业分享给企业
 * 
 * @url /ent_monitor/share
 * 
 */

export function entmonitorshare(params) {
    return axios.post('/ent_monitor/share', params)
}
/**
 * 我关注的企业取消分享给企业
 * 
 * @url /ent_monitor/close
 * 
 */

export function entmonitorclose(params) {
    return axios.post('/ent_monitor/close', params)
}
/**
 * 我关注的企业删除
 * 
 * @url /ent_monitor/delete
 * 
 */

export function entmonitordelete(params) {
    return axios.post('/ent_monitor/delete', params)
}
/**
 * 我共享的企业
 * 
 * @url /ent_monitor/my_share
 * 
 */

export function entmonitormyshare(params) {
    return axios.post('/ent_monitor/my_share', params)
}


/**
 * 推送到企业的专利
 * 
 * @url /follow_patent/my_share
 * 
 */

export function followpatentmyshare(params) {
    return axios.post('/follow_patent/my_share', params)
}
/**
 * 取消推送到企业
 * 
 * @url /follow_patent/close
 * 
 */

export function followpatentclose(params) {
    return axios.post('/follow_patent/close', params)
}
/**
 * 推送到企业专利瞭望台
 * 
 * @url /follow_patent/push
 * 
 */

export function followpatentpush(params) {
    return axios.post('/follow_patent/push', params)
}

/**
 * 原创认证文件列表
 * 
 * @url /maker/index
 * 
 */

export function makerindex(params) {
    return axios.post('/maker/index', params)
}
/**
 * 获取云盘中已认证的文件
 * 
 * @url /document/certfile
 * 
 */

export function documentcertfile(params) {
    return axios.post('/document/certfile', params)
}
/**
 * 原创认证文件详情
 * 
 * @url /maker/detail
 * 
 */

export function makerdetail(params) {
    return axios.post('/maker/detail', params)
}
/**
 * 新增原创认证
 * 
 * @url /maker/save
 * 
 */

export function makersave(params) {
    return axios.post('/maker/save', params)
}
/**
 * 删除原创认证
 * 
 * @url /maker/delete
 * 
 */

export function makerdelete(params) {
    return axios.post('/maker/delete', params)
}

/**
 * 删除原创认证
 * 
 * @url /maker/uploader
 * 
 */

export function makeruploader(params) {
    return axios.post('/maker/uploader', params)
}

/**
 * 分页获取日程
 * 
 * @url /cale/index
 * 
 */

export function caleindex(params) {
    return axios.post('/cale/index', params)
}
/**
 * 按天获取日程
 * 
 * @url /cale/find
 * 
 */

export function calefind(params) {
    return axios.post('/cale/find', params)
}

/**
 *新增日程
 * 
 * @url /cale/save
 * 
 */

export function calesave(params) {
    return axios.post('/cale/save', params)
}
/**
 *完成日程
 * 
 * @url /cale/finish
 * 
 */

export function calefinish(params) {
    return axios.post('/cale/finish', params)
}
/**
 *删除日程
 * 
 * @url /cale/del
 * 
 */

export function caledel(params) {
    return axios.post('/cale/del', params)
}

/**
 * 获取商标行业分类
 * 
 * @url /trademark_tools/industry
 * 
 */

export function trademarktoolsindustry(params) {
    return axios.post('/trademark_tools/industry', params)
}
/**
 * 商标通过率测试
 * 
 * @url /trademark_tools/rate
 * 
 */

export function trademarktoolsrate(params) {
    return axios.post('/trademark_tools/rate', params)
}